// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._10UxwkDUNsa3Gc {\n  background-color: #FDFAE5;\n  background-image: linear-gradient(to bottom right, rgba(0, 0, 0, 0.05) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.05) 75%, transparent 75%, transparent);\n  background-size: 14px 14px;\n  min-height: 30px;\n  padding: 12px 12px 12px 50px;\n  position: relative;\n}\n._10UxwkDUNsa3Gc ._1OAFUVNlthmOoC {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n}\n._10UxwkDUNsa3Gc ._3Gm00mVS3ErEHa {\n  font-size: 16px;\n  line-height: 30px;\n  margin: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"archivedBanner": "_10UxwkDUNsa3Gc",
	"archiveBannerIcon": "_1OAFUVNlthmOoC",
	"archivedBannerText": "_3Gm00mVS3ErEHa"
};
export default ___CSS_LOADER_EXPORT___;
